import React, { useEffect, useState, useCallback } from 'react';
import { Factory, Maximize2 } from 'lucide-react';
import { BarChart, Bar, ResponsiveContainer } from 'recharts';

import ProducaoTotal from './ProducaoTotal';

const MiniChart = ({ color }) => {
  const data = Array.from({ length: 10 }, () => ({ val: Math.random() * 100 }));
  return (
    <div className="h-8 w-20 opacity-30">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data}>
          <Bar dataKey="val" fill={color} radius={[1, 1, 0, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

function StatBox({ title, icon: Icon, color, border, dia, mes, onExpand }) {
  return (
    <div className={`relative bg-[#161b22] border-l-4 ${border} p-5 rounded shadow-xl flex flex-col justify-between h-full transition-all hover:bg-[#1c222a]`}>
      <button
        onClick={onExpand}
        className="absolute top-3 right-3 text-gray-600 hover:text-cyan-400 transition-colors z-20"
      >
        <Maximize2 size={18} />
      </button>

      <div className={`flex items-center gap-2 mb-6 ${color} font-black text-[10px] uppercase tracking-widest`}>
        <Icon size={24} /> <span>{title}</span>
      </div>

      <div className="flex justify-between items-end mb-4">
        <div>
          <p className="text-gray-500 text-[9px] font-bold uppercase mb-1 italic">Dia</p>
          <p className="text-white font-mono text-2xl font-bold italic tracking-tighter">
            R$ {Number(dia).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
          </p>
        </div>
        <MiniChart color="#22d3ee" />
      </div>
      <div className="flex justify-between items-center">
        <p className="text-gray-500 text-[9px] font-bold uppercase italic">Mês</p>
        <p className={`${color} font-mono text-lg font-bold italic tracking-tighter`}>
          R$ {Number(mes).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
        </p>
      </div>

    </div>
  );
}

export default function Producao(refreshSignal) {
  const [data, setData] = useState(null);

  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const base_url = 'https://onboard.fck.ind.br';

  const fetchData = useCallback(async () => {
  
    const token = localStorage.getItem('@user_token');
    if (!token) { setLoading(false); return; }


    fetch(`${base_url}/api/dashboard/producao`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`
      }
    })
      .then(res => res.json())
      .then(json => {
        // Importante: salvamos o objeto todo para o modal ter acesso aos novos campos
        setData(Array.isArray(json) ? json[0] : json);
        console.log("Dados de Produção atualizados.");
      })
      .catch(err => console.error("Erro:", err))
      .finally(() => setLoading(false));
  }, []);
  

  useEffect(() => {
      fetchData();
    }, [fetchData, refreshSignal]);


  if (loading) return <div className="border-t border-gray-800 pt-3">Carregando...</div>;

   

  return (
    <>
      <StatBox
        title="PRODUÇÃO"
        icon={Factory}
        color="text-cyan-400"
        border="border-cyan-500"
        dia={data?.producaoDia || 0}
        mes={data?.producaoMes || 0}
        onExpand={() => setIsModalOpen(true)}
      />

      {isModalOpen && (
        <ProducaoTotal
          data={data}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </>
  );
}
